export class OwnerNotificationsDeleteRequest {
  ownerNotificationId!: string

  constructor(ownerNotificationId: string) {
    this.ownerNotificationId = ownerNotificationId
  }
}
